import { useTranslation } from 'react-i18next';
import {
  ChangeEvent,
  FunctionComponent,
  KeyboardEvent,
  useEffect,
  useMemo,
  useState,
} from "react";
import PageHeader from "../../components/page-header/PageHeader";
import {
  Button,
  Col,
  Dropdown,
  Form,
  Layout,
  message,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Spin,
  Switch,
  TableColumnsType,
  TableProps,
  Tooltip,
  Typography,
} from "antd";
import FilterTable from "./components/filter-table/FilterTable";
import FormCreateUser from "./components/form-create-user/FormCreateUser";
import { DataType } from "../../types/listUsers";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  KeyOutlined,
  MoreOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import FormFilter from "./components/filter-group/FormFilter";
import { useNavigate, useSearchParams } from "react-router-dom";
import TableData from "../../components/table-data/TableData";
import { get, isEmpty } from "lodash";
import { validateFieldCreate } from "./constants/data";
import {
  changePermissionAccount,
  changeStatusAccount,
  createUser,
  deleteAccountUser,
  getAccountUsers,
  getAllEnterpriseCustomer,
  getOffices,
  getRoles,
  getUnits,
} from "../../service/list-account-users/listAccountUsersApi";
import { HelpService } from "../../service/helper.service";
import { getCurrentPageFromLink } from "../../utils/getPageFromLink";
import { combineArray } from "../../utils/arrays";
import { formatOriginTime } from "../../utils/converDate";
import DetailBasicAccountAdminDrawer from "../../components/drawer/basic-admin-account";
import ChangePassUserDrawer from "../../components/drawer/basic-admin-account/change-password";
import { globalStore } from "../../stores/stores";
import { Permission } from "../../layout/sidebar/permission.enum";
import "./list-user.scss";
import { getRoleDefaultAccount } from "../../service/management-participate-platform";
import FormItemDropdown from "../../components/form-dropdown/FormItemDropdown";

type ListUserProps = {
  title?: string;
};



const ListUser: FunctionComponent<ListUserProps> = ({ title }) => {
  const { t } = useTranslation();
  const validations = {
    type: {
      required: true,
      message: t("Vui lòng chọn loại tài khoản", "Vui lòng chọn loại tài khoản"),
    },
    role: {
      required: true,
      message: t("Vui lòng chọn vai trò", "Vui lòng chọn vai trò"),
    },
  };
  const helpService = new HelpService();
  const navigate = useNavigate();
  const { personalInfo, reload } = globalStore();
  const [params, setParams] = useSearchParams();
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [showFilter, setShowFilter] = useState<boolean>(false);
  const [isOpenBasicAccountAdmin, setIsOpenBasicAccountAdmin] =
    useState<boolean>(false);
  const [isOpenChangePass, setIsOpenChangePass] = useState<boolean>(false);
  const [statusOrder, setStatusOrder] = useState<string>("desc");
  const [fieldSortOrder, setFieldSortOrder] = useState<string>("dateJoined");
  const [detailData, setDetailData] = useState<any>();
  const [accountUsers, setAccountUsers] = useState<DataType[]>([]);
  const permissions = personalInfo?.permissions;
  const [dataOptions, setDataOptions] = useState({
    dataUnits: [],
    dataRoles: [],
    dataOffices: [],
  });

  const [filterData, setFilterData] = useState<any>({
    universityId: null,
    status: null,
    approvedDate: null,
  });

  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [searchValue, setSearchValue] = useState<string>("");
  const [mode, setMode] = useState<string>("");
  const [countItem, setCountItem] = useState<number>(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userDetail, setUserDetail] = useState<any>({});
  const [selectedPermission, setSelectedPermission] = useState<string>("");
  const [selectedRoles, setSelectedRoles] = useState<number[]>([]);
  const [listRole, setListRole] = useState<any>([]);
  const [isDaiHoc, setIsDaiHoc] = useState<boolean>(false);
  const [loadingSave, setLoadingSave] = useState<boolean>(false);
  const [loadingRole, setLoadingRole] = useState<boolean>(false);
  const [isUserTypeAccount, setIsUserTypeAccount] = useState<boolean>(false);

  const [form] = Form.useForm();

  const getListData = async () => {
    setLoading(true);
    const data = {
      page: pageNumber,
      size: pageSize,
      sort: statusOrder ? [`${fieldSortOrder},${statusOrder}`] : [],
      keyword: searchValue.trim() || undefined,
      enterpriseId: check ? null : filterData.universityId,
      isDaiHoc: filterData.universityId ? isDaiHoc : false,
      organizationId: undefined,
      createdFromDate:
        !isEmpty(filterData.approvedDate) &&
        !isEmpty(filterData.approvedDate?.[0])
          ? `${filterData.approvedDate?.[0]}T00:00:00.000Z`
          : null,
      createdToDate:
        !isEmpty(filterData.approvedDate) &&
        !isEmpty(filterData.approvedDate?.[1])
          ? `${filterData.approvedDate?.[1]}T00:00:00.000Z`
          : null,
      status: !filterData.status
        ? null
        : filterData.status === 1
        ? false
        : true,
    };

    await getAllEnterpriseCustomer(data)
      .then((res) => {
        const { data } = res.data;
        setAccountUsers(data.data);
        setTotalRecords(data.total);
        setCountItem(data?.count);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => {
        if (err.response?.status === 403) {
          navigate("/error/403");
        } else {
          console.error(err);
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    const pageLink = getCurrentPageFromLink(location.search);
    if (!isEmpty(pageLink)) {
      setPageNumber(Number(pageLink));
    } else {
      const fetchDataOptions = async () => {
        const response = await Promise.all([
          getRoles(),
          getUnits(),
          getOffices(),
        ]);
        const dataRoles = response[0].data.data;
        const dataUnits = response[1].data.data;
        const dataOffices = response[2].data.data;
        setDataOptions({
          ...dataOptions,
          dataOffices: dataOffices,
          dataUnits: dataUnits,
          dataRoles: dataRoles,
        });
      };
      fetchDataOptions();
    }
  }, [reload]);

  useEffect(() => {
    getListData();
  }, [
    pageSize,
    pageNumber,
    statusOrder,
    fieldSortOrder,
    localStorage.schoolManagement,
  ]);

  const options = [
    {
      key: "3",
      label: t("Thay đổi tài khoản", "Thay đổi tài khoản"),
      icon: <UserSwitchOutlined />,
    },
    ...(permissions?.includes(Permission.ChangeFAAccountUpdate)
      ? [
          {
            key: "0",
            label: t("Sửa tài khoản", "Sửa tài khoản"),
            icon: <EditOutlined />,
          },
          {
            key: "1",
            label: t("Đổi mật khẩu", "Đổi mật khẩu"),
            icon: <KeyOutlined />,
          },
        ]
      : []),
    ...(permissions?.includes(Permission.DeleteFAAccountUpdate)
      ? [
          {
            key: "2",
            label: t("Xóa tài khoản", "Xóa tài khoản"),
            icon: <DeleteOutlined />,
            className: "dropdown-delete",
            danger: true,
          },
        ]
      : []),
  ];

  const dataColumns: TableColumnsType<DataType> = [
    {
      title: "STT",
      dataIndex: "numericalOrder",
      key: "numericalOrder",
      width: 10,
      render: (_: any, record: any, index: number) => {
        return <div>{record?.numericalOrder}</div>;
      },
    },
    {
      title: t("Tên đăng nhập", "Tên đăng nhập"),
      dataIndex: "username",
      key: "username",
      sorter: true,
      width: 30,
    },
    {
      title: t("Họ và tên người dùng", "Họ và tên người dùng"),
      dataIndex: "name",
      key: "name",
      width: 30,
    },
    {
      title: t("Trường đại học", "Trường đại học"),
      dataIndex: "unitName",
      key: "unitName",
      width: 20,
    },
    {
      title: t("Vai trò", "Vai trò"),
      dataIndex: "vaiTros",
      key: "vaiTros",
      width: 30,
      render: (_: any, record: any) => {
        const roles = record?.roles || [];

        const content = roles.map((item: any, index: number) => (
          <p
            key={index}
            className="border rounded-md w-fit p-1 mt-1 bg-gray-100 break-all"
          >
            {item?.name}
          </p>
        ));

        return (
          <Tooltip
            title={
              <div style={{ maxHeight: "30vh", overflow: "auto" }}>
                {roles.map((item: any, idx: number) => (
                  <div key={idx}>{item?.name}</div>
                ))}
              </div>
            }
            mouseEnterDelay={0.5}
            placement="topLeft"
          >
            <div
              style={{
                maxHeight: "10vh",
                overflow: "hidden",
              }}
            >
              {content}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: t("Ngày tạo", "Ngày tạo"),
      dataIndex: "createdDate",
      key: "createdDate",
      width: 20,
      render: (_: any, record: any) => {
        return (
          <>
            {record?.dateJoined ? formatOriginTime(record?.dateJoined) : null}
          </>
        );
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      render: (_: any, record: any) => {
        const handleChange = (
          checked: boolean,
          event: React.MouseEvent<HTMLButtonElement>
        ) => {
          record.isActive = checked;
        };

        const confirm = (id: number) => {
          const data = {
            usedId: record?.id,
            isActive: record?.isActive,
          };
          changeStatusAccount(data).then((res) => {
            if (res.status === 200) {
              // record.isActive = !record?.isActive;
              helpService.successMessage(
                `${record?.isActive ? t("Mở khóa", "Mở khóa") : t("Khóa", "Khóa")} ${t("tài khoản thành công", "tài khoản thành công")}`
              );
              getListData();
            }
          });
        };

        const cancel = () => {};

        if (permissions?.includes(Permission.LockUnlockFAAccountUpdate)) {
          return (
            <Popconfirm
              description={`${t("Bạn có chắc chắn muốn", "Bạn có chắc chắn muốn")} ${
                record.isActive ? t("khóa", "khóa") : t("mở khóa", "mở khóa")
              } ${t("tài khoản?", "tài khoản?")}`}
              overlayClassName="change-status-popconfirm"
              onConfirm={() => confirm(get(record, "id"))}
              onCancel={cancel}
              okText={record.isActive ? t("Khóa", "Khóa") : t("Mở", "Mở")}
              cancelText={t("Huỷ bỏ", "Huỷ bỏ")}
              title=""
            >
              <Switch
                defaultChecked={record.isActive}
                checked={record.isActive}
                onChange={handleChange}
              />
            </Popconfirm>
          );
        } else {
          return (
            <Switch
              defaultChecked={record.isActive}
              checked={record.isActive}
              onChange={() => message.error(t("Không có quyền chỉnh sửa!", "Không có quyền chỉnh sửa!"))}
            />
          );
        }
      },
      width: 20,
    },
    {
      title: "",
      dataIndex: "action",
      key: "operation",
      render: (_, record) => {
        return (
          <Space className="flex justify-center">
            <a
              className="action-table"
              onClick={() => {
                setIsOpenBasicAccountAdmin(true);
                setDetailData(record);
              }}
            >
              <EyeOutlined />
            </a>
            <Dropdown
              menu={{
                items: options,
                onClick: ({ key }) => {
                  if (key === "0") {
                    setIsOpened(true);
                    setMode("edit");
                    setDetailData(record);
                  }
                  if (key === "1") {
                    setIsOpenChangePass(true);
                    setDetailData(record);
                  }
                  if (key === "2") {
                    Modal.confirm({
                      title: t("Xóa tài khoản", "Xóa tài khoản"),
                      content: t("Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?", "Dữ liệu đã xoá sẽ không thể khôi phục. Bạn có chắc chắn muốn xoá?"),
                      onOk: () => deleteAccount(record.id),
                      centered: true,
                      okText: t("Xác nhận", "Xác nhận"),
                      cancelText: t("Huỷ bỏ", "Huỷ bỏ"),
                      footer: (_, { OkBtn, CancelBtn }) => (
                        <>
                          <CancelBtn />
                          <OkBtn />
                        </>
                      ),
                    });
                  }
                  if (key === "3") {
                    if (record.username === personalInfo.email) {
                      message.error(
                        t("Bạn không thể tự thay đổi tài khoản của mình!", "Bạn không thể tự thay đổi tài khoản của mình!")
                      );
                      return;
                    }

                    setIsModalOpen(true);
                    setUserDetail(record);

                    let permission = "";
                    switch (record.role) {
                      case "is_qtdh":
                        permission = "1";
                        break;
                      case "is_qtcs":
                        permission = "2";
                        break;
                      case "is_giang_vien":
                        permission = "3";
                        break;
                      default:
                        break;
                    }

                    form.setFieldValue(
                      "roleAccount",
                      record.roles?.map((item: any) => {
                        return String(item.id);
                      })
                    );
                    setIsUserTypeAccount(true);
                    setSelectedPermission(permission);
                  }
                },
              }}
              placement="bottomRight"
            >
              <Button>
                <MoreOutlined />
              </Button>
            </Dropdown>
          </Space>
        );
      },
      fixed: "right",
      width: 15,
    },
  ];

  const defaultCheckedList = dataColumns.map((item) => item.key as string);
  const [checkedList, setCheckedList] = useState(defaultCheckedList);

  const newColumns = useMemo(() => {
    return dataColumns.map((item) => ({
      ...item,
      hidden: !checkedList.includes(item.key as string),
    }));
  }, [checkedList, permissions]);

  const handleOpenCreate = () => {
    setIsOpened(true);
    setDetailData([]);
    setMode("add");
  };

  const handleOpenFilter = () => {
    setShowFilter((showFilter) => !showFilter);
  };

  const handleClose = () => {
    setIsOpened(false);
    form.resetFields();
  };

  const handleChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    setParams({ [name]: value });
    setSearchValue(value);
    if (value.length === 0) {
      setSearchValue("");
      setParams();
    }
  };

  const handleSearch = (e: KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === "Enter") {
      getListData();
    }
  };

  const handleSubmitSearch = () => {
    getListData();
  };

  const check = !permissions?.includes(Permission.isQTHT);

  const clearFilter = () => {
    const allFields = form.getFieldsValue();
    const fieldsToReset = Object.keys(allFields).filter(
      (key) => key !== "universityId"
    );
    check ? form.resetFields(fieldsToReset) : form.resetFields();
    setFilterData({
      universityId: check ? filterData.universityId : null,
      status: null,
      approvedDate: null,
    });
  };

  const handleFinish = (values: any) => {
    setLoading(true);
    getAccountUsers({
      vaiTros: get(values, "vaiTros", []),
      donVis: combineArray(dataOptions.dataUnits, get(values, "donVis", [])),
      trangThai: get(values, "trangThai", []),
    }).then((res) => {
      const { data, totalRecords } = res.data.data;
      setLoading(false);
      setAccountUsers(data);
      setTotalRecords(totalRecords);
    });
  };

  const onFinishCreate = (values: any) => {
    createUser(values)
      .then((res) => {
        const { data, statusCode } = res.data;
        if (statusCode === 200) {
          helpService.successMessage(
            get(data, "message", t("Tạo tài khoản thành công", "Tạo tài khoản thành công"))
          );
          form.resetFields();
          setPageNumber(1);
          handleClose();
        }
      })
      .catch((err) => {});
  };

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    let data = "";
    if (!sorter.order) {
      data = "desc";
      setFieldSortOrder("dateJoined");
    } else {
      data =
        sorter.order === "ascend"
          ? "asc"
          : sorter.order === "descend"
          ? "desc"
          : "";
      setFieldSortOrder(sorter.field);
    }
    setStatusOrder(data);
  };

  const handleChangeFilter = (value: any, name: string) => {
    setFilterData({ ...filterData, [name]: value });
  };

  const handleCloseFilter = () => {
    setShowFilter(false);
  };

  const listBreadcrumb = [
    {
      title: t("Quản trị cơ sở", "Quản trị cơ sở"),
    },
  ];

  const deleteAccount = async (id: number) => {
    try {
      const res = await deleteAccountUser(id);
      if (res.status === 200) {
        message.success(t("Xóa tài khoản thành công", "Xóa tài khoản thành công"));
        if (countItem === 1 && pageNumber > 1) {
          setPageNumber(pageNumber - 1);
        } else {
          getListData();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  // get role
  const getRoleByPermission = async () => {
    setLoadingRole(true);
    const data = {
      keyword: "",
      pageNumber: 1,
      pageSize: 999999,
      checkRole: selectedPermission === "3" ? "2" : "1",
    };

    try {
      const res = await getRoleDefaultAccount(data);
      if (res.data.statusCode === 200) {
        const listData = res.data?.data?.map((role: any) => ({
          value: role.id,
          label: role.name,
        }));
        setListRole(listData);
        setLoadingRole(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingRole(false);
    }
  };

  // Change permission
  const changePermission = async () => {
    setLoadingSave(true);
    const dataReq = {
      userIds: [userDetail.id],
      typeAccount: Number(selectedPermission),
      universityUUID: userDetail.uuid,
      groupIds: selectedRoles,
    };
    try {
      const res = await changePermissionAccount(dataReq);
      if (res.status === 200) {
        setLoadingSave(false);
        message.success(t("Thay đổi vai trò thành công", "Thay đổi vai trò thành công"));
        handleCancel();
        getListData();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingSave(false);
      handleCancel();
    }
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedRoles([]);
    setSelectedPermission("");
    form.resetFields();
  };

  const permissionOptions = [
    ...((permissions?.includes(Permission.isQTDH) ||
      permissions?.includes(Permission.isMinistry) ||
      permissions?.includes(Permission.isQTHT)) &&
    (userDetail.role === "is_qtdh" || userDetail.unitParentUuid)
      ? [
          {
            value: "1",
            label: t("Quản trị đại học", "Quản trị đại học"),
          },
        ]
      : []),
    {
      value: "2",
      label: t("Quản trị cơ sở", "Quản trị cơ sở"),
    },
    {
      value: "3",
      label: t("Giảng viên", "Giảng viên"),
    },
  ];

  useEffect(() => {
    if (selectedPermission) {
      form.setFieldValue("typeAccount", selectedPermission);
      getRoleByPermission();
    }
  }, [selectedPermission]);

  return (
    <Layout className="page-header-group">
      <Form.Provider
        onFormFinish={(name, { values, forms }) => {
          if (name === "createUser") {
            const { createUser } = forms;
            const data = createUser.getFieldsValue(validateFieldCreate);
            onFinishCreate(data);
          }
          if (name === "filterForm") {
            getListData();
          }
        }}
      >
        <div
          className={`page-header-group--layout ${
            showFilter ? "open-filter" : ""
          }`}
        >
          <div className="table-header--wrapper">
            <div className="table-header--left">
              <PageHeader title={title} listBreadcrumb={listBreadcrumb} />
            </div>
            <FilterTable
              handleOpen={handleOpenCreate}
              searchValue={searchValue}
              dataColumns={dataColumns}
              handleOpenFilter={handleOpenFilter}
              handleSubmitSearch={handleSubmitSearch}
              handleSearch={handleSearch}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
              handleChangeInput={handleChangeInput}
            />
          </div>
          <FormFilter
            form={form}
            check={check}
            showFilter={showFilter}
            filterData={filterData}
            clearFilter={clearFilter}
            setIsDaiHoc={setIsDaiHoc}
            setFilterData={handleChangeFilter}
            handleCloseFilter={handleCloseFilter}
          />
        </div>

        <TableData
          dataTable={accountUsers}
          dataColumns={newColumns}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          pageNumber={pageNumber}
          pageSize={pageSize}
          pagination={true}
          loadingTable={loading}
          scroll={{ x: 1500, y: 600 }}
          totalRecords={totalRecords}
          handleTableChangeProps={handleTableChange}
        />

        <FormCreateUser
          open={isOpened}
          handleClose={handleClose}
          fetchData={getListData}
          detailData={detailData}
          mode={mode}
        />

        <DetailBasicAccountAdminDrawer
          open={isOpenBasicAccountAdmin}
          onClose={() => setIsOpenBasicAccountAdmin(false)}
          detailData={detailData}
        />

        <ChangePassUserDrawer
          open={isOpenChangePass}
          onClose={() => setIsOpenChangePass(false)}
          detailData={detailData}
          fetchData={getListData}
        />
        <Modal
          title={t("Thay đổi tài khoản", "Thay đổi tài khoản")}
          maskClosable={false}
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          okText={t("Lưu", "Lưu")}
          cancelText={t("Huỷ bỏ", "Huỷ bỏ")}
          okButtonProps={{ disabled: loadingSave || isUserTypeAccount }}
          cancelButtonProps={{ disabled: loadingSave }}
          className="change-permission-modal"
        >
          <Form form={form} onFinish={() => changePermission()}>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="typeAccount"
                  label={t("Loại tài khoản", "Loại tài khoản")}
                  rules={[validations.type]}
                >
                  <FormItemDropdown
                    options={permissionOptions}
                    placeholder={t("Chọn loại tài khoản", "Chọn loại tài khoản")}
                    onChange={(value) => {
                      setSelectedPermission(value);
                      setSelectedRoles([]);

                      let permission = "";
                      switch (userDetail.role) {
                        case "is_qtdh":
                          permission = "1";
                          break;
                        case "is_qtcs":
                          permission = "2";
                          break;
                        case "is_giang_vien":
                          permission = "3";
                          break;
                        default:
                          break;
                      }

                      if (value === permission) {
                        setIsUserTypeAccount(true);
                        form.setFieldValue(
                          "roleAccount",
                          userDetail.roles?.map((item: any) => {
                            return String(item.id);
                          })
                        );
                      } else {
                        setIsUserTypeAccount(false);
                        form.setFieldValue("roleAccount", []);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col className="flex roles-col" span={24}>
                <div
                  style={{
                    minHeight: 32,
                    width: "100%",
                    alignContent: "center",
                  }}
                >
                  <Form.Item
                    name="roleAccount"
                    label={t("Vai trò", "Vai trò")}
                    rules={[validations.role]}
                  >
                    {loadingRole ? (
                      <Spin size="small" />
                    ) : (
                      <FormItemDropdown
                        allowClear
                        options={listRole}
                        modeDropdown="multiple"
                        placeholder={t("Chọn vai trò", "Chọn vai trò")}
                        disabled={isUserTypeAccount}
                        onChange={(value) =>
                          setSelectedRoles(value?.map(Number))
                        }
                      />
                    )}
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Form.Provider>
    </Layout>
  );
};

export default ListUser;
